const Class = require('class.extend');
const onTransitionEnd = require('proper-on-transition-end');
const EventEmitterMixin = require('silvermine-event-emitter');

const Analytics = Class.extend(EventEmitterMixin).extend({
    init: function() {
        this.links = document.querySelectorAll('.information a');
        this.hover = document.querySelector('.hover');
        this.details = document.querySelector('.details');
        this.inner = document.querySelector('.details .inner');
        this.copy = document.querySelector('.details .inner p');
        this.image = document.querySelector('.placeholder img');
        this.link = '';

        this.systemEvents();
        this.setup();
    },
    systemEvents: function() {
        this.on('clicked', () => this.moveHover())
            .on('changeText', () => this.removeText())
            .on('setHeight', () => this.setHeight())
            .on('addNewCopy', () => this.addCopy())
            .on('newHeight', () => this.newHeight())
            .on('revealCopy', () => this.revealCopy());
    },
    setup: function() {
        this.links.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                this.link = event;
                this.emit('clicked');
            });
        });
    },
    moveHover: function() {
        this.setActive();
        this.hover.style.cssText = 'top: ' + this.link.target.parentNode.offsetTop + 'px';
        this.emit('changeText');
    },
    removeText: function() {
        this.details.classList.add('remove');
        this.emit('setHeight');
    },
    setHeight: function() {
        const currentHeight = this.inner.offsetHeight,
              options = { timeout: 200 };

        onTransitionEnd(this.details, options, () => {
            this.inner.style.cssText = 'height: ' + currentHeight + 'px';
            this.copy.innerText = '';
            this.emit('addNewCopy');
        });
    },
    addCopy: function() {
        this.copy.innerText = this.link.target.parentNode.getAttribute('data-copy');
        this.image.src = this.link.target.parentNode.getAttribute('data-image');
        this.emit('newHeight');
    },
    newHeight: function() {
        const newHeight = this.copy.offsetHeight;

        this.inner.style.cssText = 'height: ' + ( newHeight + 32 ) + 'px';
        this.emit('revealCopy');
    },
    revealCopy: function() {
        // this.details.classList.remove('remove');
        const options = { timeout: 500 };

        onTransitionEnd(this.details, options, () => {
            this.details.classList.remove('remove');
        });
    },
    setActive: function() {
        this.links.forEach((link) => {
            link.parentNode.classList.remove('active');
        });
        this.link.target.parentNode.classList.add('active');
    }
});

module.exports = new Analytics();



// WEBPACK FOOTER //
// ./assets/js/analytics.js